import styles from './LogoAndRights.module.scss';
import { CommonImage } from '~/components/common/image/CommonImage';
import { path } from '~/utils/path';

interface Params {
  className?: string;
}

export const LogoAndRights = ({ className = '' }: Params) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles['logo-wrap']}>
        <CommonImage src={path.image('/common/icon-logo.svg')} width={240} height={72} />
      </div>
      <small className={styles.rights}>&copy; 2026 ASICS Corporation. All Rights Reserved.</small>
    </div>
  );
};
